import { useRoomsContext } from '../contexts/roomsContext';
import { useConfigContext } from '../contexts/configContext';
import { countTravelersFromRooms } from '../utils/roomReducerUtil';

export const useStepperMaximum = (roomIndex) => {
  const {
    rooms,
  } = useRoomsContext();

  const {
    maxAdults,
    maxChildren,
    maxInfants,
    maxTravelersCap,
    maxTravelersPerRoom,
    maxCombinedChildrenAndInfants,
  } = useConfigContext();

  const { adults, children, infants } = rooms[roomIndex];

  const totalTravelers = countTravelersFromRooms(rooms);

  const valueForAdultUsingMaxTravelerCap = maxTravelersCap
    ? (maxTravelersCap - totalTravelers) + adults : maxAdults;

  const valueForAdultsUsingMaxTravelersPerRoom = maxTravelersPerRoom
    ? maxTravelersPerRoom - (children?.length || 0) - (infants?.length || 0) : maxAdults;
  const maxAdultsForStepper = Math.min(maxAdults,
    valueForAdultUsingMaxTravelerCap,
    valueForAdultsUsingMaxTravelersPerRoom);

  const valueForChildrenUsingMaxTravelerCap = maxTravelersCap
    ? (maxTravelersCap - totalTravelers) + (children?.length || 0) : maxChildren;

  const valueForChildrenUsingMaxTravelersPerRoom = maxTravelersPerRoom
    ? maxTravelersPerRoom - adults - (infants?.length || 0) : maxChildren;

  const valueForChildrenUsingMaxCombinedChildrenAndInfants = maxCombinedChildrenAndInfants
    ? maxCombinedChildrenAndInfants - (infants?.length || 0) : maxChildren;

  const maxChildrenForStepper = Math.min(maxChildren,
    valueForChildrenUsingMaxCombinedChildrenAndInfants,
    valueForChildrenUsingMaxTravelerCap,
    valueForChildrenUsingMaxTravelersPerRoom);

  const valueForInfantsUsingMaxTravelerCap = maxTravelersCap
    ? (maxTravelersCap - totalTravelers) + (infants?.length || 0) : maxInfants;

  const valueForInfantsUsingMaxTravelersPerRoom = maxTravelersPerRoom
    ? maxTravelersPerRoom - adults - (children?.length || 0) : maxInfants;

  const valueForInfantsUsingMaxCombinedChildrenAndInfants = maxCombinedChildrenAndInfants
    ? maxCombinedChildrenAndInfants - (infants?.length || 0) : maxInfants;

  const maxInfantsForStepper = Math.min(maxInfants,
    valueForInfantsUsingMaxCombinedChildrenAndInfants,
    valueForInfantsUsingMaxTravelerCap,
    valueForInfantsUsingMaxTravelersPerRoom);

  return {
    maxAdultsForStepper,
    maxChildrenForStepper,
    maxInfantsForStepper,
  };
};
